module.exports = __webpack_public_path__ + "img/9cc2083.jpg";